/** @format */

const template = `
<div class="course-unit-info-modal">
  <div class="course-unit-info-modal-header courseunit cu-color-0">
    <div class="credits-box">
      <span class="credit-amount">{{ ctrl.courseUnit.credits | creditRange }}</span>
      <span class="credit-abbreviation" translate>STUDIES.COURSE_UNIT_INFO_MODAL.CREDITS_ABBREVIATION</span>
    </div>
    <div class="info-box">
      <div class="top-section">
        <div class="code-and-name">
          <div class="course-unit-code">{{ ctrl.courseUnit.code }}</div>
          <h2 ng-if="ctrl.courseUnit.name[ctrl.contentLanguage]" class="modal-title">
            {{ctrl.courseUnit.name[ctrl.contentLanguage]}}
            <span
              ng-if="ctrl.courseUnit.documentState==='DRAFT' || ctrl.courseUnit.documentState==='DELETED'"
              class="tiny-badge"
              ng-class="{'accent': ctrl.courseUnit.documentState==='DRAFT',
                             'danger': ctrl.courseUnit.documentState==='DELETED'}">
              {{'DOCUMENT_STATE.' + ctrl.courseUnit.documentState | translate}}
            </span>
          </h2>
          <h2 ng-if="!ctrl.courseUnit.name[ctrl.contentLanguage]" class="modal-title">({{ctrl.fallBackName}})</h2>
        </div>
        <div class="top-icons">
          <button ng-click="ctrl.close()" class="btn-close" type="button" aria-label="{{'ARIA_LABEL.CLOSE' |translate}}">
            <sis-icon icon="close-big"></sis-icon>
          </button>
        </div>
      </div>
      <div class="middle-section">
        <sis-contextual-notification ng-if="!ctrl.courseUnit.name[ctrl.contentLanguage]" variant="warning"
          >{{'STUDIES.COURSE_UNIT_INFO_MODAL.NO_NAME_IN_SELECTED_LANGUAGE' | translate }}</sis-contextual-notification
        >
        <sis-course-unit-version-selector
          ng-if="ctrl.courseUnitVersions.length"
          [current-course-unit]="ctrl.courseUnit"
          (change)="ctrl.setCourseUnitVersion($event)"
          [course-unit-versions]="ctrl.courseUnitVersions"
          [display-names-by-course-unit-id]="ctrl.displayNamesByCourseUnitId">
        </sis-course-unit-version-selector>
        <sis-contextual-notification ng-if="ctrl.belongsToCurrentCurriculumPeriod===false" variant="warning"
          >{{'STUDIES.COURSE_UNIT_INFO_MODAL.BELONGS_TO_DIFFERENT_CURRICULUM_PERIOD' | translate }}</sis-contextual-notification
        >
      </div>
      <div class="bottom-section">
        <sis-tab-content-switch
          [type]="'pills'"
          [tabs]="ctrl.tabs"
          [(current-index)]="ctrl.activeTab"
          [scope]="ctrl.scope"></sis-tab-content-switch>
        <div ng-if="ctrl.locales.length > 1" class="language-nav">
          <sis-language-pills [gray]="true" [scope]="ctrl.scope" [(selected-language)]="ctrl.contentLanguage"></sis-language-pills>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-body">
    <div ng-if="ctrl.activeTab == 0">
      <sis-plan-course-unit-info-modal-basic-info
        [course-unit]="ctrl.courseUnit"
        [language]="ctrl.contentLanguage"></sis-plan-course-unit-info-modal-basic-info>
    </div>
    <div ng-if="ctrl.activeTab == 1">
      <sis-completion-methods [course-unit]="ctrl.courseUnit" [language]="ctrl.contentLanguage"></sis-completion-methods>
    </div>
    <div ng-if="ctrl.activeTab == 2">
      <sis-prior-learning-substitutions-container [course-unit]="ctrl.courseUnit"></sis-prior-learning-substitutions-container>
    </div>
  </div>
</div>
`;
export default template;
